var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OImage',{attrs:{"src":_vm.profilePictureUrl,"alt":((_vm.item.name) + " Profil Resmi"),"width":_vm.width,"height":_vm.height,"loading":"lazy"}})}
var staticRenderFns = []

export { render, staticRenderFns }